import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["href", "title", "subtitle", "likes"];
import React from 'react';
import classnames from 'classnames/bind';
import { defaultPropArray } from "../../../../constants";
import { ChevronNormalRight, HeartLinear } from "../../../../icons";
import { TextBase } from "../../../../internal/TextBase";
import { Highlighter } from '../Highlighter';
import styles from './SearchResults.css';
var cx = classnames.bind(styles);
export var SearchResults = function SearchResults(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? defaultPropArray : _ref$items,
      searchValue = _ref.searchValue,
      hideFirstDivider = _ref.hideFirstDivider;
  return /*#__PURE__*/React.createElement("div", null, items.map(function (_ref2, index) {
    var href = _ref2.href,
        title = _ref2.title,
        subtitle = _ref2.subtitle,
        likes = _ref2.likes,
        rest = _objectWithoutProperties(_ref2, _excluded);

    return /*#__PURE__*/React.createElement("a", _extends({
      // eslint-disable-next-line react/no-array-index-key
      key: "search-result-".concat(index)
    }, rest, {
      href: href,
      className: cx('item', {
        hide_first_divider: hideFirstDivider
      })
    }), Boolean(likes) && /*#__PURE__*/React.createElement("div", {
      className: cx('likes')
    }, /*#__PURE__*/React.createElement("span", {
      className: cx('like-icon')
    }, /*#__PURE__*/React.createElement(HeartLinear, {
      height: 16,
      width: 16
    })), /*#__PURE__*/React.createElement(TextBase, {
      as: "span",
      color: "N80",
      size: "s"
    }, likes)), /*#__PURE__*/React.createElement("div", {
      className: cx('title')
    }, /*#__PURE__*/React.createElement(TextBase, {
      as: "span",
      size: "l",
      weight: "semibold"
    }, title), /*#__PURE__*/React.createElement("span", {
      className: cx('expand-icon')
    }, /*#__PURE__*/React.createElement(ChevronNormalRight, null))), subtitle && /*#__PURE__*/React.createElement("div", {
      className: cx('subtitle')
    }, /*#__PURE__*/React.createElement(TextBase, {
      as: "span",
      color: "N80",
      size: "s"
    }, /*#__PURE__*/React.createElement(Highlighter, {
      text: subtitle || title,
      highlight: searchValue
    }))));
  }));
};